import { AbstractDataProviderV2 } from 'components/system';
import { RsCustomerSportParams } from 'common/customers/services/types/RsCustomerSportParams';
import { CustomerSportParamsPatch } from 'common/customers/services/types/CustomerSportParamsPatch';
import { HttpUpdateMethod } from 'components/system/data-provider/models';

export class CustomerSportParamsDataProvider extends AbstractDataProviderV2<{}, RsCustomerSportParams, {}, {}, CustomerSportParamsPatch> {
    protected updateMethod: HttpUpdateMethod = 'PATCH';

    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/sport-params');
    }

    public list(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public add(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public remove(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public update(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
